<template>
    <v-container fluid>
        <v-alert
            dense
            outlined
            type="error"
            v-if="Object.keys(validation_errors).length > 0"
        >
        <ul>
            <li v-for="(errors, field) in validation_errors" :key="field">
                {{ field }}
                <ul>
                    <li v-for="(error, sl) in errors" :key="sl">
                        {{ error }}
                    </li>
                </ul>
            </li>
        </ul>
        </v-alert>
        <v-row>
            <v-col cols="12" class="py-1">
                <v-card :elevation="1">
                    <v-toolbar color="white" :elevation="1" height="30px">
                        <v-toolbar-title class="subtitle-2"
                            >Area Entry</v-toolbar-title
                        >
                    </v-toolbar>

                    <v-card-text class="py-0">
                        <v-form
                            @submit.prevent="saveArea"
                            ref="areaForm"
                            class="custom-form"
                        >
                            <v-row class="justify-center">
                                <v-col cols="7">
                                    <v-row>
                                        <v-col cols="2" class="py-1 caption"
                                            >Name</v-col
                                        >
                                        <v-col cols="6" class="py-0">
                                            <v-text-field
                                                dense
                                                outlined
                                                hide-details
                                                :rules="[(v) => !!v]"
                                                v-model.trim="area.name"
                                                :error-messages="validation_errors.name"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="4" class="py-0">
                                            <v-btn
                                                type="submit"
                                                height="26px"
                                                dark
                                                color="light-blue darken-2"
                                                :elevation="1"
                                                class="mr-1"
                                                :loading="loading"
                                                >Save</v-btn
                                            >
                                            <v-btn
                                                height="26px"
                                                dark
                                                color="deep-orange"
                                                :elevation="1"
                                                @click="resetForm"
                                                >Cancel</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" class="pb-0">
                <v-data-table
                    class="custom-data-table elevation-1"
                    dense
                    :headers="areaHeaders"
                    :items="$store.getters['area/areas']"
                    :search="searchArea"
                >
                    <template v-slot:top>
                        <v-toolbar
                            dense
                            color="white"
                            :elevation="1"
                            height="30px"
                        >
                            <v-toolbar-title class="subtitle-2"
                                >Area List</v-toolbar-title
                            >
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-form class="custom-form">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    placeholder="Search Area"
                                    append-icon="mdi-magnify"
                                    style="width: 300px"
                                    v-model="searchArea"
                                >
                                </v-text-field>
                            </v-form>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    small
                                    @click="editArea(item)"
                                    color="primary"
                                    v-on="on"
                                    >mdi-circle-edit-outline</v-icon
                                >
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    small
                                    @click="deleteArea(item)"
                                    color="error"
                                    v-on="on"
                                    >mdi-delete-circle-outline</v-icon
                                >
                            </template>
                            <span>Delete</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "Areas",

    data() {
        return {
            areaHeaders: [
                { text: "Name", value: "name" },
                { text: "Action", value: "action" },
            ],
            searchArea: "",
            area: {
                name: "",
            },
            editId: null,
            validation_errors: {},
            loading: false,
        };
    },

    created() {
        this.$store.dispatch("area/getAreas");
    },

    methods: {
        async saveArea() {
            if (!this.$refs.areaForm.validate()) return;

            this.loading = true;

            let data = {
                url: "/add-area",
                area: this.area,
            };

            if (this.editId) {
                data.url = "/update-area";
                data.area.id = this.editId;
            }

            let res = await this.$store.dispatch(
                "area/saveArea",
                data
            );

            if(res.hasOwnProperty("validation_errors")){
                this.validation_errors = res.validation_errors;
            }

            this.loading = false;

            if(res.isSuccess) this.resetForm();
        },
        editArea(area) {
            this.area.name = area.name;
            this.editId = area.id;
        },
        deleteArea(area) {
            if (!confirm("Are you sure?")) return;

            this.$store.dispatch(
                "area/deleteArea",
                area.id
            );
        },
        resetForm() {
            this.area.name = "";
            this.editId = null;
            this.$refs.areaForm.resetValidation();
        },
    },
};
</script>

<style>
</style>
